import { Loader } from "@3sc/common-component";
import { Box } from "@mui/material";
import React from "react";

const ProcessingLoader = () => {
  return (
    <Box alt="loader">
      <Loader />
    </Box>
  );
};

export default ProcessingLoader;
